exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span[data-v-3600b0fc]{color:#fff}.cont[data-v-3600b0fc]{background:#fff;border-top:1px solid #ddd}.right[data-v-3600b0fc]{padding-top:10px;line-height:24px}.right span[data-v-3600b0fc]{cursor:pointer;margin-right:5px}", "", {"version":3,"sources":["/./src/components/web/WebFooter.vue"],"names":[],"mappings":"AACA,sBACE,UAAY,CACb,AACD,uBACE,gBAAiB,AACjB,yBAA2B,CAC5B,AACD,wBACE,iBAAkB,AAClB,gBAAkB,CACnB,AACD,6BACE,eAAgB,AAChB,gBAAkB,CACnB","file":"WebFooter.vue","sourcesContent":["\nspan[data-v-3600b0fc] {\n  color: #fff;\n}\n.cont[data-v-3600b0fc] {\n  background: #fff;\n  border-top: 1px solid #ddd;\n}\n.right[data-v-3600b0fc] {\n  padding-top: 10px;\n  line-height: 24px;\n}\n.right span[data-v-3600b0fc] {\n  cursor: pointer;\n  margin-right: 5px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-3600b0fc&scoped=true!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/components/web/WebFooter.vue
// module id = 211
// module chunks = 0